import {
  IRefreshAuthToken,
  RENEW_TOKEN_INTERVAL_MILLISECONDS
} from '../../store/ducks/auth/types';
import {
  commerceApiWithoutRequestInterceptor,
  ECustomerAuthorizationEndpoints,
  TOKEN_NOT_FOUND
} from '../api';
import { EGerdauService } from '../EGerdauService';
import { ERefreshTokenEndpoints, refreshAuthTokenApi } from './api';

export interface IRefreshAuthTokenService {
  refreshAuthToken: () => Promise<IRefreshAuthToken>;
}

export class RefreshAuthTokenService
  extends EGerdauService
  implements IRefreshAuthTokenService
{
  async refreshAuthToken(): Promise<IRefreshAuthToken> {
    const headers = {
      client_id: process.env.REACT_APP_token_client_id,
      client_secret: process.env.REACT_APP_token_client_secret
    };
    const bodyRequest = {};

    const refreshAuthTokenResponse = await refreshAuthTokenApi.post(
      `${ERefreshTokenEndpoints.REFRESH_TOKEN}`,
      { ...bodyRequest },
      { headers }
    );

    try {
      const newToken = refreshAuthTokenResponse.data as IRefreshAuthToken;
      return newToken;
    } catch (err) {
      console.error(err);
      throw new Error('Não foi possível atualizar token');
    }
  }

  async checkAndRefreshToken() {
    const response = await this.refreshAuthToken();
    const azureDateTimeExpiration =
      new Date().getTime() + RENEW_TOKEN_INTERVAL_MILLISECONDS;

    RefreshAuthTokenService.setAuthorizationToken(response.access_token);
    RefreshAuthTokenService.setAuthorizationTokenExpiration(
      azureDateTimeExpiration.toString()
    );
  }

  //Adobe token GR-600
  async validateCommerceToken(): Promise<string> {
    try {
      this.checkAndRefreshToken();

      const headers = super.getHeaders();
      const access_token = super.getToken();

      if (!access_token) {
        throw new Error('Não foi encontrado o @access_token');
      }

      const validateResponse = await commerceApiWithoutRequestInterceptor.post(
        `${ECustomerAuthorizationEndpoints.VALIDATE}`,
        { access_token },
        { headers }
      );

      if (!validateResponse.data.commerce_token) {
        throw TOKEN_NOT_FOUND;
      }

      EGerdauService.setCommerceToken(validateResponse.data.commerce_token);

      return validateResponse.data.commerce_token;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
}
